import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { setKey, session } from "../store/actions";
import { connect } from "react-redux";
import DataGrid from './DataGrid';
import moment from 'moment';
import adService from '../services/ad';
import { swalDeleteForm, swalError, swalSmallForm, swalSuccess } from "../utils/swal";
import utils from "../utils/utils";

function StatsAds({
    session,
    setKey,
    ...props
}) {
    const { i18n } = useTranslation();
    const [keyword, setKeyword] = useState(``);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        reload();
    }, [keyword]);

    const reload = async () => {
        await adService.getViews(session.token, keyword)
            .then(result => {
                if (result.error) {
                    swalError(result.error);
                    return;
                }

                if (Array.isArray(result.data)) {
                    setRows(result.data);
                } else {
                    setRows([]);
                    console.error("StatsAds: Expected array but got:", result.data);
                }
            });
    }

    const _clms = [{
        headerName: "Title",
        field: "ad.title"
    }, {
        headerName: "Views Count",
        field: "count",
        cellRenderer: p => utils.getCurrencyFormattedNumber(p.value)
    }];

    return (
        <div className="container">
            <div className="row mt-10">
                <div className="col text-left">
                    <h3>Ads Views</h3>
                </div>
                <div className="col text-right">
                    <button className="btn btn-light" onClick={e => { e.preventDefault(); reload(); }}>
                        <i className="fa fa-sync"></i>
                        Reload
                    </button>
                </div>
            </div>
            <div className="row mt-10">
                <div className="col">
                    <input type="text" className="form-control" placeholder="Type to search..."
                        value={keyword} onChange={e => setKeyword(e.target.value)} />
                </div>
            </div>
            <div className="row mt-10">
                <div className="col">
                    <DataGrid
                        columnDefs={_clms}
                        rowData={rows}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = store => ({
    session: store.session
});

const mapDispatchToProps = dispatch => ({
    setKey: (key, value) => dispatch(setKey(key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(StatsAds);